import React from 'react';
import './pricing.css';
import NavHeader from './NavHeader';
import Footer from './Footer';

const Pricing = () => {
        const handleGetStartedClick = () => {
        window.open('https://play.google.com/store/apps/details?id=com.civilnotesapp&hl=en', '_blank');
    };
    return (
        <div>
            <NavHeader />

            <div className="pricing-section">
                <h2 className="pricing-title">Pricing plans for everyone</h2>
                <p className="pricing-subtitle">Choose the plan that suits your needs</p>

                <div className="pricing-cards">

                    {/* Free Plan */}
                    <div className="pricing-card">
                        <h3>Free</h3>
                        <p className="price">₹0 <span>/month</span></p>
                        <ul>
                            <li>First 2 chapters of every subject</li>
                            <li>Handwritten descriptive notes</li>
                        </ul>
                        <button onClick={handleGetStartedClick} className="get-started">Get started</button>
                    </div>

                    {/* Lifetime Plan - Center */}
                    <div className="pricing-card popular">
                        <div className="popular-label">Most Popular</div>
                        <h3>Lifetime</h3>
                        <p className="price">₹555 <span>/one-time</span></p>
                        <ul>
                            <li>All handwritten notes</li>
                            <li>All chapters unlocked</li>
                            <li>Lifetime access</li>
                        </ul>
                        <button onClick={handleGetStartedClick} className="get-started">Get started</button>
                    </div>

                    {/* Annual Plan */}
                    <div className="pricing-card">
                        <h3>Annual</h3>
                        <p className="price">₹333 <span>/year</span></p>
                        <ul>
                            <li>All handwritten notes</li>
                            <li>All chapters unlocked</li>
                            <li>Yearly access</li>
                        </ul>
                        <button onClick={handleGetStartedClick} className="get-started">Get started</button>
                    </div>

                </div>
            </div>

            <Footer currentPath={'privacy'} />
        </div>
    );
};

export default Pricing;
